import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig } from "@/utils/constants/configContants";
import { ALL_GROUPS } from "@/utils/constants/constants";
import { storeInLocalStorage } from "@/utils/functions/helperFunctions";

export const fetchGroups = async (pageNo: number, dataLength: number, sorting: any, callback: any, errorCallback: any) => {
    axios
        .get(`${BASEDOMAIN}/group/list?offset=${dataLength * pageNo - dataLength}&limit=${dataLength}&sort=${JSON.stringify(sorting)}`, AuthConfig())
        .then((response) => {
            callback(response);
            storeInLocalStorage(ALL_GROUPS, response.data.groups);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response?.data);
        });
};

export const fetchAllGroups = async (callback: any, errorCallback: any) => {
    axios
        .get(`${BASEDOMAIN}/group/list`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response?.data);
        });
}

export const saveGroup = async (data: any, callback: any, errorCallback: any) => {
    await axios
        .post(`${BASEDOMAIN}/group`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
};
export const getGroupById = async (id: string, callback: any, errorCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/group/${id}`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
}

export const updateGroup = async (id: string, data: any, callback: any, errorCallback: any) => {
    await axios
        .patch(`${BASEDOMAIN}/group/${id}`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
}

export const getGroupUsers = async (id: string, callback: any, errorCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/group/${id}/users`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
}